import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { User } from '@spartacus/core';
import {
  MessageService,
  UserChangePasswordFormComponent,
  UserChangePasswordFormService,
  UserItemService,
} from '@spartacus/organization/administration/components';
import { LoadStatus } from '@spartacus/organization/administration/core';
import { first, switchMap, take, filter, map, tap } from 'rxjs/operators';
import { UigUserItemService } from 'src/app/organization/services/uig-user-item/uig-user-item.service';
import { UigB2BUser } from 'src/app/organization/uig-user/uig-user.model';
import { UIGUserChangePasswordFormService } from 'src/app/services/uig-user-change-password-form.service';

@Component({
    selector: 'app-uig-user-change-password-form',
    templateUrl: './uig-user-change-password-form.component.html',
    styleUrls: ['./uig-user-change-password-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'content-wrapper' },
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigUserChangePasswordFormComponent
  extends UserChangePasswordFormComponent
  implements OnInit {
  userID: string;
  constructor(
    protected itemService: UserItemService,
    protected formService: UIGUserChangePasswordFormService,
    protected messageService: MessageService,
    private uigUserItemService: UigUserItemService
  ) {
    super(itemService, formService, messageService);
  }

  ngOnInit() {
    this.itemService.current$.pipe(
      tap((item) => {
        this.userID = item?.uid;
      })
    ).subscribe();
  }
  save(form: UntypedFormGroup): void {
    this.uigUserItemService.current$
      .pipe(
        first(),
        switchMap((item) =>
          this.uigUserItemService
            .update((form.value as UigB2BUser).customerId, this.getPatchedItem(form.value as UigB2BUser))
            .pipe(
              take(1),
              filter((data) => data.status === LoadStatus.SUCCESS),
              map((data) => ({
                ...item,
                ...data.item,
              }))
            )
        )
      )
      .subscribe((data) => {
        this.notify(data);
        this.uigUserItemService.launchDetails(data);
      });
  }

  protected getPatchedItem(item): UigB2BUser {
    const patch = {};
    patch['customerId'] = item['customerId'];
    patch['uid'] = item['customerId'];
    patch['password'] = item['password'];
    patch['confirmPassword'] = item['confirmPassword'];
    patch['edit'] = true;
    return patch as UigB2BUser;
  }
}
